// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KO6i6pu,button.KO6i6pu{display:inline-flex;justify-content:center;align-items:center;margin:-0.25em;padding:.25em;cursor:pointer;color:#9199a3;border:0;outline:none;background:none}.KO6i6pu:focus-visible,button.KO6i6pu:focus-visible{outline:initial}.KO6i6pu.qDAtzaM,button.KO6i6pu.qDAtzaM{color:#ff1f78}.dY2ik2t{width:1.5em;height:1.5em;font-size:16px;pointer-events:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `KO6i6pu`,
	"isActive": `qDAtzaM`,
	"icon": `dY2ik2t`
};
export default ___CSS_LOADER_EXPORT___;
